<template>
    <div class="content">
        <div class="success">
            <img src="../../static/img/success.png" alt="">
            <p>付款成功</p>
            <div class="amount">
                <div>WWW.BOSUM.COM</div>
                <div v-if="amount">￥{{amount}}</div>
            </div>
        </div>
    </div>
</template>

<script>
import customerService from '@/api/customerService'
export default {
    name: "paymentSuccess",
    data() {
        return {
           amount:''
        }
    },
    mounted() {
     if(this.$route.query.amount){
        this.amount = this.$route.query.amount
     }
     if(this.$route.query.orderId){
        this.polypaySuccess(this.$route.query.orderId)
     }
    },
    methods: {
         polypaySuccess() {
        var vm = this;
        customerService.polypaySuccess(vm,orderId).then(function(data){
        });
      },
    }
}
</script>

<style scoped>
.content{
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 16px;
}
.success{
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}
.success>img{
    width: 90px;
    height: 90px;
}
.success>p{
    font-size: 24px;
    font-weight: 600;
    color: #000000;
}
.amount{
    width: 100%;
    background: #F7F7F7;
    border-radius: 4px;
    padding: 20px 16px;
    margin: 40px 0;
    font-size: 14px;
    font-weight: bold;
    color: #9E9E9E;
    display: flex;
    justify-content: space-around;
}
</style>



// WEBPACK FOOTER //
// src/views/paymentSuccess.vue